'use client';
/** @jsxImportSource @emotion/react */

import type { LinearProgressProps } from '@mui/material/LinearProgress';

import MuiLinearProgress from '@mui/material/LinearProgress';

export type { LinearProgressProps };
export const LinearProgress = MuiLinearProgress;
